import AuthenticationLayout from '../SignUp/elements/AuthenticationLayout';

import { CreateFirstProjectForm } from './CreateFirstProjectForm';

const CreateFirstProject = () => {
  return (
    <div className="w-full">
      <div
        style={{ backgroundImage: 'url(./assets/images/first-project-bg.jpg)' }}
        className="h-screen w-screen bg-cover bg-top lg:block hidden"
      >
        <div className="w-full max-w-max py-2.5 pl-2.5 pr-11 h-full max-h-[673px] border border-base-border bg-base-background fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg shadow-md flex gap-x-11">
          <img
            className="h-full max-w-[443px] object-contain"
            src="./assets/images/first-project-modal-bg.png"
            alt="first-project-modal-bg"
          />
          <CreateFirstProjectForm />
        </div>
      </div>
      <AuthenticationLayout
        className="lg:hidden"
        main={<CreateFirstProjectForm />}
      />
    </div>
  );
};

export default CreateFirstProject;
